<template>
  <b-card>
    <h3 class="text-center mb-3">Crear Auxiliar</h3>
    <validation-observer ref="infoRules" tag="form">
      <b-row>
        
        <b-col md="6" class="mb-1">
          <label>Tipo Identificación: <span class="text-danger">*</span></label>
          <validation-provider v-slot="{ errors }" name="tipoIdent" rules="required">
            <b-form-select 
              id="v-type-ident" 
              v-model="auxiliar.tipoIdentificacion" 
              :options="opsTipoIdent"
              :state="errors.length > 0 ? false : null" 
            />
            <div v-if="errors.length > 0" class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </b-col>

        <b-col md="6" class="mb-1">
          <label>Identificación: <span class="text-danger">*</span></label>
          <validation-provider #default="{ errors }" v-slot="{ errors }" name="identificacion" :rules="identificacionRules">
            <b-form-input 
              id="mc-identificacion" 
              v-model="auxiliar.identificacion" 
              placeholder="0999999999"
              name="identificacion" 
              type="text" 
              :maxlength="maxInputLength"
              :state="errors.length > 0 ? false : null" 
            />
            <div v-if="errors.length > 0" class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </b-col>

        <b-col md="6" class="mb-1">
          <label>Apellidos: <span class="text-danger">*</span></label>
          <validation-provider #default="{ errors }" name="apellido" rules="required">
            <b-form-input 
              id="v-lastname" 
              :state="errors.length > 0 ? false : null" 
              v-model="auxiliar.apellidos"
              type="text" 
              placeholder="Escriba su apellido" 
            />
          </validation-provider>
        </b-col>

        <b-col md="6" class="mb-1">
          <label>Nombres: <span class="text-danger">*</span></label>
          <validation-provider #default="{ errors }" name="nombre" rules="required">
            <b-form-input 
              id="v-name" 
              :state="errors.length > 0 ? false : null" 
              v-model="auxiliar.nombres" 
              type="text"
              placeholder="Escriba su nombre" 
            />
          </validation-provider>
        </b-col>

        <b-col md="6" class="mb-1">
          <label>Fecha de nacimiento: <span class="text-danger">*</span></label>
          <validation-provider v-slot="{ errors }" name="fechaNacimiento" rules="required">
            <flat-pickr 
              class="flatpickr-container"
              v-model="auxiliar.fechaNacimiento" 
              :state="errors.length > 0 ? false : null" 
              locale="es"
              :config="birthDateConfig"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col md="6" class="mb-1">
          <label>Fecha de Inicio: <span class="text-danger">*</span></label>
          <validation-provider v-slot="{ errors }" name="fechaInicioDoctor" rules="required">
            <flat-pickr 
              class="flatpickr-container"
              id="v-fechainicio" 
              v-model="auxiliar.fechaInicio" 
              :state="errors.length > 0 ? false : null"
              locale="es" 
              :config="birthDateConfig"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col md="6" class="mb-1">
          <label>Celular: <span class="text-danger">*</span></label>
          <validation-provider #default="{ errors }" name="celular" rules="required">

            <b-form-tags 
              id="v-cell" 
              input-id="tags-validation" 
              v-model="auxiliar.telefono"
              :input-attrs="{ 'aria-describedby': 'tags-validation-help' }" 
              :tag-validator="tagValidator"
              :state="errors.length > 0 ? false : null" 
              separator=" " 
              input-type="number"
              placeholder="099999999" 
            />
          </validation-provider>
        </b-col>

        <b-col md="6" class="mb-1">
          <label>Correo eletrónico: <span class="text-danger">*</span></label>
          <validation-provider 
            #default="{ errors }" 
            name="Correo eletrónico" 
            rules="required|email"
          >
            <b-form-input 
              id="mc-email" 
              v-model="auxiliar.email" 
              placeholder="ana@example.com" 
              name="email"
              :state="errors.length > 0 ? false : null" 
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>


        <b-col md="6" class="mb-1">
          <label>Tipo Auxiliar: <span class="text-danger">*</span></label>
          <validation-provider v-slot="{ errors }" name="tipoauxiliar" rules="required">
            <v-select 
              id="v-tipoauxiliar" 
              v-model="auxiliar.tipoAuxiliar"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
              :options="tipoAuxiliarOpts"
              :selectable="option => !option.value.includes('select_value')" 
              label="text"
              :class="{ 'is-invalid': errors.length > 0 }" 
            />
            <div v-if="errors.length > 0" class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </b-col>

        <div class="col-8 p-1 mx-1 my-1" style="border: 1px solid #ccc">
          <LoadFileInput 
            v-model="auxiliar.firmaSello" 
            :urlFile="auxiliar.urlFirmaSello"
            label="Url firma y sello"
            inline
          />
        </div>

        <b-col class="col-12 text-right">
          <b-button @click="onSaveAuxiliar" variant="primary">
            Guardar
          </b-button>
        </b-col>

      </b-row>

      
    </validation-observer>

  </b-card>
</template>
<script>
import vSelect from 'vue-select'
import { required, email } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { BootstrapVue } from 'bootstrap-vue';
import axios from 'axios';
import { LoadFileInput } from '@/shared/components';
import { personasService } from '../../../admision/services';
import { auxiliarMedicoService } from '../../services';
import { fileService } from '../../../../shared/services';


export default {
  components: {
    ...BootstrapVue.components,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    LoadFileInput
  },

  data() {
    return {


      auxiliar:{
        tipoIdentificacion : null,
        identificacion     : null,
        apellidos          : null,
        nombres            : null,
        fechaNacimiento    : null,
        telefono           : null,
        email              : null,
        fechaInicio        : null,
        tipoAuxiliar       : null,
        urlFirmaSello      : null,
        firmaSello         : null
      },

      errors: [],
      email,
      required,

      tipoAuxiliarOpts: [],

      opsTipoIdent: [
        { value: '0', text: 'RUC' },
        { value: '1', text: 'Cedula' },
        { value: '2', text: 'Pasaporte' }
      ],

      
      birthDateConfig: {
        allowInput: true
      },
    }
  },


  created() {
    this.loadDataForm();
    this.setToken();
  },


  methods: {

    async loadDataForm() {
      this.tipoAuxiliarOpts = await auxiliarMedicoService.getTipos();
    },


    tagValidator(tag) {
      const isValid = /^\d+$/.test(tag) && tag.length < 11
      this.tagError = isValid ? '' : 'Solo se permiten valores numéricos hasta de 10 caracteres'
      return isValid
    },


    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },




    async onSaveAuxiliar(){

      const dataPersona = {
        tipoIdentificacion : this.auxiliar.tipoIdentificacion,
        identificacion     : this.auxiliar.identificacion,
        apellidos          : this.auxiliar.apellidos,
        nombres            : this.auxiliar.nombres,
        fechaNacimiento    : this.auxiliar.fechaNacimiento,
        telefono           : this.auxiliar.telefono.join(','),
        email              : this.auxiliar.email,
        residenciaDefault  : true
      }
      
      const responseCreate = await personasService.addPersona(dataPersona);
      if(!responseCreate) return;

      const idPersona = responseCreate.id;

      let urlFirmaSello = null;
      if(this.auxiliar.firmaSello){
        urlFirmaSello = await fileService.upload(
          'firmaSello',
          this.auxiliar.firmaSello,
          this.auxiliar.identificacion,
          this.auxiliar.urlFirmaSello
        )
      }

      const dataAuxiliar = {
        auxiliarMedicoData: {
          idPersona     : parseInt(idPersona),
          tipoAuxiliar  : this.auxiliar.tipoAuxiliar?.value,
          fechafin      : '',
          urlFirmaSello : urlFirmaSello || '',
          fechainicio   : this.auxiliar.fechaInicio
        }
      };

      const responseGuardarAuxiliar = await auxiliarMedicoService.registrar(dataAuxiliar);
      if(!responseGuardarAuxiliar) return;

      await this.$swal({
        title: 'Auxiliar Creado',
        icon: 'success',
        confirmButtonColor: '#089599',
      });
    },

  },

  computed: {
    identificacionRules() {
      // Reglas de validación dinámicas basadas en el tipo de identificación
      if (this.tipoIdent === '1') {
        return 'required|integer|digits:10';
      } else if (this.tipoIdent === '0') {
        return 'required|integer|digits:13';
      } else if (this.tipoIdent === '2') {
        return 'required'; // Para Pasaporte (números y letras)
      }
    },

    inputType() {
      if (this.tipoIdent === '2') return 'text'; // Pasaporte
      return 'number'; // Cédula o RUC
    },

    maxInputLength() {
      if (this.tipoIdent === '0') return 13; // RUC
      return 10; // Pasaporte
    },

  },


  watch: {

    auxiliar:{
      deep: true,
      handler(newValue){
        console.log('auxiliar', newValue)
      }
    }
  },
}
</script>


<style>
.flatpickr-container {
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  display: block;
  width: 100%;
  height: 2.714rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
